import React from 'react';
import {connect} from 'react-redux';
import PersonalDetails from './PersonalDetails/PersonalDetails';
import InfoProducts from './InfoProducts/InfoProducts';
import Credit from '../Credit/Credit';
import Message from './Message/Message';
import QuestionsAnswers from './QuestionsAnswers/QuestionsAnswers';

function DetailsMonthlyCharges(props) {
  const billingCycle = props.invoicesInfo.main?.billingCycle?.toString();

  return (
    <div className='details-month'>
      <div>
        {billingCycle?.includes('202501') && <Message></Message>}
        <PersonalDetails
          onClickUpdateMailing={props.onClickUpdateMailing}
          onClickPdfInvoice={props.onClickPdfInvoice}
          banDetails={props.banDetails}
          billInfo={props.invoicesInfo?.main}
          personalDetails={props.personalDetails}
          isEnergy={props.isEnergy}
          guidId={props.guidId}
          systemSourcePDF={props.systemSourcePDF}
        />
        <Credit />
        <InfoProducts />
        {props.detailsProducts.length > 0 && <QuestionsAnswers />}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    // page: state.personalAreaInvoicesPage.page,
    banDetails: state.personalAreaInvoicesPage.selectedBan.details,
    detailsProducts: state.personalAreaInvoicesPage.detailsProducts,
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo,
    personalDetails: state.personalAreaInvoicesPage.personalDetails,
    isEnergy: state.personalAreaInvoicesPage.isEnergy,
    guidId: state.personalAreaInvoicesPage.guidId,
    systemSourcePDF: state.personalAreaInvoicesPage.systemSourcePDF,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsMonthlyCharges);
